/* eslint-disable class-methods-use-this */
import { BinType } from 'commons/enums';
import { IBin, ProductDetail } from 'commons/types';

import { SwipeRxWmsApi } from '../resources';
import { SwipeRxAPIResources } from '../resources/types';

import {
  BulkCheckInboundTaskItemRequest,
  BulkCheckInboundTaskItemResponse,
  CheckInboundTaskItemRequest,
  InboundTaskItemAssignUnassignRequest,
  InboundTaskRemoveBatchRequest,
  PostBulkUnassignItemByInboundTaskNumberRequest,
  PostInboundTaskItemRequest,
} from './type';

class SwipeRxWmsApiInboundTaskItem extends SwipeRxWmsApi {
  private readonly basePath: string;

  constructor() {
    super(SwipeRxAPIResources.INBOUND_TASK_ITEM);
    this.basePath = `/${this.apiResource}`;
  }

  async assignTask(
    payload: InboundTaskItemAssignUnassignRequest,
  ): Promise<void> {
    try {
      const response = await this.post(`${this.basePath}/assign`, payload);
      return response;
    } catch (error) {
      console.warn(error);
      throw error;
    }
  }

  async unassignTask(
    payload: InboundTaskItemAssignUnassignRequest,
  ): Promise<void> {
    try {
      const result = await this.post(`${this.basePath}/unassign`, payload);
      return result;
    } catch (error) {
      console.warn(error);
      throw error;
    }
  }

  async bulkUnassignItemByInboundTaskNumber(
    payload: PostBulkUnassignItemByInboundTaskNumberRequest,
  ): Promise<void> {
    try {
      const result = await this.post(
        `${this.basePath}/bulk-unassign-by-task-number`,
        payload,
      );
      return result;
    } catch (error) {
      console.warn(error);
      throw error;
    }
  }

  async getBinRecommendationInfo(
    skuCode: string,
    binType: BinType,
  ): Promise<ProductDetail[]> {
    const result = await this.get(
      `${this.apiResource}/${skuCode}/bin-recommendation/${binType}/info`,
    );

    return result.data;
  }

  async getValidateBin(bin: string): Promise<IBin | null> {
    const result = await this.get(`${this.basePath}/bin`, { bin_number: bin });
    return result.data;
  }

  async postReceiveItem(params: PostInboundTaskItemRequest): Promise<void> {
    await this.post(`${this.basePath}/receive`, params);
  }

  async postRemoveBatch(params: InboundTaskRemoveBatchRequest): Promise<void> {
    await this.post(`${this.basePath}/remove-batch`, params);
  }

  async checkInboundTaskItem(
    params: CheckInboundTaskItemRequest,
  ): Promise<void> {
    const endpoint = params.approved
      ? `${this.basePath}/approve`
      : `${this.basePath}/reject`;

    const payload = {
      inbound_task_number: params.inbound_task_number,
      invoice_number: params.invoice_number,
      sku_code: params.sku_code,
      foc: params.foc,
    };

    await this.post(endpoint, payload);
  }

  async bulkCheckInboundTaskItem(
    params: BulkCheckInboundTaskItemRequest,
  ): Promise<BulkCheckInboundTaskItemResponse> {
    const endpoint = params.approved
      ? `${this.basePath}/bulk-approve`
      : `${this.basePath}/bulk-reject`;

    const payload = {
      inbound_task_number: params.inbound_task_number,
      invoice_number: params.invoice_number,
      items: params.items,
    };

    const response = await this.post(endpoint, payload);
    return response.data;
  }
}

export const swipeRxWmsApiInboundTaskItem = new SwipeRxWmsApiInboundTaskItem();
